<template>
    <v-dialog-old class="specsDialog" ref="dialog" @hidden="resetData()">
        <form>
          <fieldset style=" min-width: 1000px">
            <legend>
              Специальности врача
            </legend>
            <div style="-webkit-column-count:4; -moz-column-count:4; column-count:4;">
              <template v-for="option in specialityOptions">
                <label>
                  <input type="checkbox" v-model="checked"
                         :value="option.value" :class="{'level2': option.level == '2'}"
                         :disabled="checked.length >= checkedMax && !checked.includes(option.value)"
                  />
                  <span>{{option.text}}</span>
                </label>
              </template>
            </div>
          </fieldset>
        </form>

        <template v-slot:footer>
            <button class="green" @click="acceptChanges">Подтвердить</button>
        </template>
    </v-dialog-old>
</template>

<script>
export default {
    name: "DoctorSpecialitiesDialog",

    props: {
        specialityOptions: {
            type: Array,
            required: true
        },
    },

    data: function () {
        return {
            checked: this.$attrs.value,
            checkedMax: 30
        };
    },

    methods: {
      resetData() {
        this.checked = this.$attrs.value;
      },
      acceptChanges: function () {
        this.$emit('input', this.checked)
        this.$nextTick(() => {
          this.resetData();
          this.$refs.dialog.hide();
        });
      }
    },

    computed: {

    },
    watch: {
        '$attrs.value': {
            immediate: false,
            handler(newValue) {
                this.checked = newValue;
            }
        },
    }
}
</script>
<style>
.specsDialog > #vdialog {
  width: 1317px !important;
}
</style>
